/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import * as _ from 'lodash';

import {ApiConfig} from '../../api';
import {AdnHttpService} from '../../../util/adn-http.service';
import {AdnHttpSender, createAdnHttpResourceSender} from '../../../util/create-adn-http-resource';
import {AuthHttpInterceptorService} from '../../../auth/auth-http-interceptor.service';
import {ApiErrorHandlerService} from '../../../../app/common/directives/error/api-error-handler.service';



@Injectable({
  providedIn: 'root'
})
export class LoginStatsService {
  private readonly send: AdnHttpSender;

  constructor(
    AdnHttp: AdnHttpService,
    authHttpInterceptor: AuthHttpInterceptorService,
    ApiErrorHandler: ApiErrorHandlerService
  ) {
    this.send = createAdnHttpResourceSender(AdnHttp, authHttpInterceptor, ApiErrorHandler);
  }

  getForUser(userId?: string): Promise<any> {
    const uriParts = ['loginstats'];
    if (userId) {
      uriParts.push(userId);
    }
    return this.send({
      method: 'GET',
      url: ApiConfig.obtain().getVersionedUri(uriParts),
      params: _.assign({}, {format: 'json'})
    });
  }
}
